@import '~style-sheet-helpers/core.less';
@import '../../../app-brand/entities/entity-layer.module.less';

.open {
  .item-header-icon {
    transform: rotate(-180deg);
  }
}

.collapsible-list-item-header {
  display: flex;
  flex-direction: row;
  background: @collapsable-list--header--background-color;
  cursor: pointer;
  line-height: 46px;
  height: 46px;
  font-size: 14px;
  overflow: hidden;
  color: @collapsable-list--header--text-color;
  border-bottom: 1px solid @collapsable-list--header--border-color;

  &.white {
    background: @collapsable-list--header--light--background-color;
    font-size: 21px;
  }

  &.no-content,
  &.disabled {
    cursor: default;
  }

  &.disabled {
    opacity: 0.5;
  }
}

.collapsible-list-item-header-content {
  flex-grow: 1;
  padding: 0 10px;
}

.item-header-icon {
  width: 30px;
  height: 100%;
  transition: all 300ms ease;

  > svg {
    .vertical-align();
    fill: @collapsable-list-header--chevron--icon-color;
  }
}
